import Navigator from 'app';
import BillsHomeLayout from './views/bills_home_layout';
// for showBillHome
import BillHomeLayout from './views/bills_home_layout';
import WatchedBillCategoryCollectionView from './views/category_list_collectionview';
import WatchedBillCollection from '../../entities/watched_bill/watched_bill_collection';
import WatchedBillCategoryCollection from '../../entities/watched_bill/watched_bill_category_collection';
import NewestBIllsCollection from '../../entities/bill/newest_bills_collection';
import PassedBillsCollection from '../../entities/bill/passed_bills_collection';
// for showSearchResults
import BillSearchCollectionView from './views/bill_search_collectionview';
import '../../entities/bill/bill_search_collection';
// for showWatchedBillCategory
import CategoryShowLayout from './views/category_show_layout';
import CategoryShowHeadlineView from './views/category_show_headline_itemview';
import WatchedBillCollectionView from './views/watchedbill_list_collectionview';
import FilteredCollection from '../../entities/common/filtered_collection';
// for showBillDetail
import BillDetailModel from '../../entities/bill/bill_detail_model';
//import StoryCollection from '../../entities/story/story_collection'; //broken
import BillDetailLayout from './views/bill_detail_layout';
import BillDetailItemview from './views/bill_detail_itemview';
import BillDetailAuthorItemview from './views/bill_detail_author_itemview';
import BillDetailAuthorCompositview from './views/bill_detail_author_compositview';
import BillDetailStatusCollectionview from './views/bill_detail_status_collectionview';
import BillDetailVersionCollectionview from './views/bill_detail_version_collectionview';
import BillDetailVoteCompositview from './views/bill_detail_vote_compositview';
import StoryCompositView from '../common/views/story_compositview';
import BillsListCollection from '../../entities/bill/bill_list_collection';
import BillListLayout from './views/bill_list_layout';
import BillsListCompositeView from './views/bills_list_compositeview';
import HeadlineItemview from '../common/views/headline_itemview';
export default {
  showBillHome: function () {
    var billHomeLayout = new BillHomeLayout();
    var fetchingWatchedBills = Navigator.request("watched_bill:list");
    var fetchingNewestBIlls = Navigator.request("bills:new");
    var fetchingPassedBIlls = Navigator.request("bills:passed");
    Navigator.vent.trigger("loading:show");
    if (!Navigator.vent._events['bills:search:applied']) {
      Navigator.vent.on("bills:search:applied", function (filter) {
        filter.route = `bills/${filter.value}`;
        Navigator.guest.sendMessage(filter);
        console.log("EMD bills:search:applied", filter);
      });
    }
    $.when(fetchingWatchedBills, fetchingNewestBIlls, fetchingPassedBIlls).done(function (watchedBills, newBills, passedBills) {
      // returns array of objects with name and bill count for each category
      var categoryModelData = _.chain(watchedBills.models).countBy(function (model) {
        return model.get("category");
      }).pairs().map(function (model) {
        return {
          name: model[0],
          count: model[1]
        };
      }).value();
      var billCategoryCollection = new WatchedBillCategoryCollection(categoryModelData);
      var billCategoriesView = new WatchedBillCategoryCollectionView({
        collection: billCategoryCollection
      });
      billHomeLayout.on("show", function () {
        billHomeLayout.watchedBillsCategoryRegion.show(billCategoriesView);
      });
      Navigator.vent.trigger("loading:hide");
      Navigator.mainRegion.show(billHomeLayout);
    });
  },
  showSearchResults: function (params) {
    var billHomeLayout = new BillHomeLayout();
    var fetchingBillSearchResults = Navigator.request("bill:search", params);
    Navigator.vent.trigger("loading:show");
    $.when(fetchingBillSearchResults).done(function (searchResults) {
      var billSearchResults = new BillSearchCollectionView({
        collection: searchResults
      });
      billHomeLayout.on("show", function () {
        billHomeLayout.watchedBillsCategoryRegion.show(billSearchResults);
      });
      Navigator.vent.trigger("loading:hide");
      Navigator.mainRegion.show(billHomeLayout);
    });
  },
  showWatchedBillCategory: function (category) {
    var fetchingWatchedBills = Navigator.request("watched_bill:list");
    var categoryLayout = new CategoryShowLayout();
    var headline = category.replace(/\_/g, " ");
    var headlineModel = new Backbone.Model({
      headline: headline
    });
    var headlineView = new CategoryShowHeadlineView({
      model: headlineModel
    });
    Navigator.vent.trigger("loading:show");
    $.when(fetchingWatchedBills).done(function (watchedBills) {
      //watched bill collection that can be filtered by category
      var filteredWatchedBills = new FilteredCollection({
        collection: watchedBills
      });
      filteredWatchedBills.filter({
        category: category
      });
      var watchedBillCollectionView = new WatchedBillCollectionView({
        collection: filteredWatchedBills
      });
      categoryLayout.on("show", function () {
        categoryLayout.headlineRegion.show(headlineView);
        categoryLayout.billListRegion.show(watchedBillCollectionView);
      });
      Navigator.vent.trigger("loading:hide");
      Navigator.mainRegion.show(categoryLayout);
    });
  },
  showBillDetail: function (param) {
    // param is appended to the end of the api request url -- it can be
    // either the bill id or a string with the doc type (i.e. HB) and
    // bill number separated by a '/'
    var fetchingBill = Navigator.request("bill:detail", param);
    var billDetailLayout = new BillDetailLayout();
    Navigator.vent.trigger("loading:show");
    $.when(fetchingBill).done(function (bill) {
      const billDetailView = new BillDetailItemview({
        model: bill
      });
      const authorView = new BillDetailAuthorItemview({
        model: bill.get("author"),
        primary_author: true
      });
      const coauthorView = new BillDetailAuthorCompositview({
        collection: bill.get("coauthors")
      });
      const statusView = new BillDetailStatusCollectionview({
        collection: bill.get("bill_status_listings")
      });
      const versionView = new BillDetailVersionCollectionview({
        collection: bill.get("versions")
      });
      const voteView = new BillDetailVoteCompositview({
        collection: bill.get("votes")
      });
      const billNameConvert = {
        HB: 'housebill',
        HR: 'houseresolution',
        SB: 'senatebill',
        SR: 'senateresolution'
      };
      const storyTag = billNameConvert[bill.get("document_type")] + bill.get("number");
      const fetchingStories = Navigator.request("bill:stories", storyTag);
      $.when(fetchingStories).done(function (stories) {
        const storiesView = new StoryCompositView({
          collection: stories
        });
        billDetailLayout.on("show", function () {
          billDetailLayout.billRegion.show(billDetailView);
          billDetailLayout.authorRegion.show(authorView);
          billDetailLayout.coauthorsRegion.show(coauthorView);
          billDetailLayout.statusRegion.show(statusView);
          billDetailLayout.versionRegion.show(versionView);
          if (voteView.collection.length > 0) {
            // fallback to default text if no votes
            billDetailLayout.voteRegion.show(voteView);
          }
        });
        Navigator.vent.trigger("loading:hide");
        Navigator.mainRegion.show(billDetailLayout);
      });
    }).fail(function (error) {
      console.error(error);
      Navigator.vent.trigger("loading:hide");
      Navigator.vent.trigger("fail");
    });
  },
  showBillList: function (list) {
    const head = {
      "house_passed": "Bills passed by House",
      "senate_passed": "Bills passed by Senate",
      "sent_to_gov": "Bills sent to Governor",
      "signed": "Bills signed by Governor",
      "vetoed": "Bills vetoed"
    };
    const headlineModel = new Backbone.Model({
      headline: head[list]
    });
    const headlineItemView = new HeadlineItemview({
      model: headlineModel
    });
    const billListLayout = new BillListLayout();
    const fetchingBillsList = Navigator.request("bill:list", list);
    Navigator.vent.trigger("loading:show");
    $.when(fetchingBillsList).done(function (bills) {
      const billsListCompositeView = new BillsListCompositeView({
        collection: bills
      });
      billListLayout.on("show", function () {
        billListLayout.headlineRegion.show(headlineItemView);
        billListLayout.billListRegion.show(billsListCompositeView);
      });
      Navigator.vent.trigger("loading:hide");
      Navigator.mainRegion.show(billListLayout);
    });
  }
};